module.exports = __webpack_public_path__ + "static/media/sedeunion.d663ecdc.webp";